"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiSnackbarContentOverrides = function (_a) {
    var _b, _c;
    var spacing = _a.spacing, breakpoints = _a.breakpoints, typography = _a.typography;
    return ({
        root: (_b = {
                padding: spacing(2, 4),
                backgroundColor: undefined,
                color: undefined,
                boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.3)"
            },
            _b[breakpoints.up("xl")] = {
                padding: spacing(3, 4),
                fontSize: typography.pxToRem(16),
            },
            _b),
        message: (_c = {
                padding: spacing(1, 0)
            },
            _c[breakpoints.up("xl")] = {
                padding: 0,
            },
            _c),
        action: {
            marginRight: undefined,
            paddingLeft: spacing(3),
        },
    });
};
//# sourceMappingURL=MuiSnackbarContent.js.map